var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"separator-container"},[_c('div',{staticClass:"separator-gradient"}),_c('div',{class:['separator-line', _vm.orientation]})])
}
var staticRenderFns = []

export { render, staticRenderFns }